import styled from '@emotion/styled';
import { customProperties as vars } from '@resi-media/resi-ui';

export const IconWrapper = styled.span`
  margin-right: ${vars.spacingS};
  display : inline-grid;
`;
